import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { PortfolioConfig } from './types/config';
import { loadConfig } from './utils/configLoader';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Blogs from './components/Blogs';

import Contact from './components/Contact';
import Footer from './components/Footer';
import Loading from './components/Loading';

function App() {
  const [config, setConfig] = useState<PortfolioConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPortfolioConfig = async () => {
      try {
        const portfolioConfig = await loadConfig();
        setConfig(portfolioConfig);
      } catch (error) {
        console.error('Failed to load config:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPortfolioConfig();
  }, []);

  if (loading || !config) {
    return <Loading />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-white dark:bg-dark-900">
        <Navbar config={config} />
        
        <main>
          <Routes>
            <Route path="/" element={
              <AnimatePresence>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Hero config={config} />
                  <About config={config} />
                  <Skills config={config} />
                  <Experience config={config} />
                  <Projects config={config} />
                  <Blogs config={config} />
                  <Contact config={config} />
                </motion.div>
              </AnimatePresence>
            } />
          </Routes>
        </main>
        
        <Footer config={config} />
      </div>
    </Router>
  );
}

export default App;
